import { RectangleButton } from "../Actions";
import Content from "./Content";
import CB from "../../assets/Coinbase.svg";
import MM from "../../assets/MetaMask.svg";

const AlreadyWallet: React.FC<{
  onClickNo: () => void;
  onClickMeta: () => void;
  onClickCb: () => void;
}> = ({ onClickNo, onClickCb, onClickMeta }) => {
  return (
    <>
      <Content
        title={"Do you have a wallet on Coinbase or MetaMask already?"}
        description={"How about a Coinbase account?"}
        tooltipContent={{
          title: "Wallet Tip",
          description:
            "A Coinbase wallet is different from a Coinbase account. If you're not sure, you probably don’t have a wallet."
        }}>
        <div className="flex flex-col tab:flex-row gap-4 w-full mt-6">
          <RectangleButton
            analyticsProperty="yes on coinbase"
            color="teal"
            onClick={onClickCb}>
            <CB width="48" className="mb-2" />
            Yes, on Coinbase
          </RectangleButton>
          <RectangleButton
            color="teal"
            analyticsProperty="yes on metamask"
            onClick={onClickMeta}>
            <MM width="48" className="mb-2" />
            Yes, on Metamask
          </RectangleButton>
        </div>
        <div className="w-full flex tab:mt-4">
          <RectangleButton
            onClick={onClickNo}
            color="teal"
            analyticsProperty="no i don't have a wallet">
            No, I don&apos;t have a Wallet
          </RectangleButton>
        </div>
      </Content>
    </>
  );
};

export default AlreadyWallet;
